import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = 'Inflation Impact Calculator';
const DESCRIPTION = 'The Inflation Impact Calculator calculates the amount of money that loses its value due to inflation between two different time periods.';
const KEYWORDS = 'Inflation impact on money, calculate inflation impact, inflation calculator';
const OG_URL = 'https://do-calculate.com/calculator/en/inflation';
function InflationCalculator() {
    const [initialAmount, setInitialAmount] = useState('');
    const [initialDollarRate, setInitialDollarRate] = useState('');
    const [finalDollarRate, setFinalDollarRate] = useState('');
    const [result, setResult] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!initialAmount || !initialDollarRate || !finalDollarRate) {
            setError('Please enter all values correctly');
            setResult('');
            return;
        }
        const initialAmountValue = parseFloat(initialAmount);
        const initialDollarRateValue = parseFloat(initialDollarRate);
        const finalDollarRateValue = parseFloat(finalDollarRate);
        if (isNaN(initialAmountValue) || isNaN(initialDollarRateValue) || isNaN(finalDollarRateValue)) {
            setError('Please enter valid numeric values');
            setResult('');
            return;
        }
        const initialValueInDollars = initialAmountValue / initialDollarRateValue;
        const finalValueInDollars = initialAmountValue / finalDollarRateValue;
        const lossInDollars = initialValueInDollars - finalValueInDollars;
        const lossPercentage = (lossInDollars / initialValueInDollars) * 100;
        setResult(
            `Original amount in dollars: ${initialValueInDollars.toFixed(2)} dollars <br/>
            Value after inflation in dollars: ${finalValueInDollars.toFixed(2)} dollars <br/>
            Loss in dollars: ${lossInDollars.toFixed(2)} dollars <br/>
            Loss percentage: ${lossPercentage.toFixed(2)}%`
        );
        setError('');
    };
    return (
        <div className='ltr'>
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                        <h2 style={{ fontSize: '18px' }}>How to Calculate Inflation Impact</h2>
                                        <p>
                                            The calculation of inflation impact involves calculating the difference in the value of money between two different time periods based on the inflation rate.
                                        </p>
                                        <p>
                                            Loss = Original amount - Value after inflation
                                        </p>
                                        <p>
                                            Loss percentage = (Loss / Original amount) * 100%
                                        </p>
                                        <hr />
                                    </div>
                                </div>
                                <MobileUnderCalAds />
                                <div className="row">
                                    <div className="col-sm-12 col-md-7 calculatorStyle">
                                        <div className='p-3 mb-2 bg-success text-white'>
                                            <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                        </div>
                                        <hr />
                                        <div>
                                            <div>
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Original Amount</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="10000"
                                                        value={initialAmount}
                                                        onChange={(e) => setInitialAmount(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Value of Original Amount in Dollars</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="30"
                                                        value={initialDollarRate}
                                                        onChange={(e) => setInitialDollarRate(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '90%' }}
                                                    />
                                                </div>
                                                <br />
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Value of Original Amount in Dollars in the Second Period</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="40"
                                                        value={finalDollarRate}
                                                        onChange={(e) => setFinalDollarRate(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '90%' }}
                                                    />
                                                </div>
                                                <br />
                                                <button
                                                    className="btn btn-success"
                                                    style={{ fontSize: '20px' }}
                                                    onClick={handleCalculate}
                                                >
                                                    Calculate Inflation Impact
                                                </button>
                                            </div>
                                            <br />
                                            <div>
                                                {error !== '' ? (
                                                    <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
                                                ) : (
                                                    <>
                                                        {result !== '' && (
                                                            <>
                                                                <p className='p-3 mb-2 bg-success text-white'>
                                                                    Result:
                                                                </p>
                                                                <p className='p-3 mb-2 bg-info text-black' dangerouslySetInnerHTML={{ __html: result }}></p>
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <RelatedLinks />
                                    <hr />
                                </div>
                            </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.physicsCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
             <br />
        </div>
    );
}
export default InflationCalculator;
